/**
 * Clean the canonical URL by removing the /pwa/ prefix if it appears at the start of the path.
 * The function handles both full URLs and relative paths, preserving query parameters and hash fragments.
 * Special cases:
 * - Only removes /pwa/ from the start of paths, not from the middle or end
 * - Handles empty strings by returning them unchanged
 * - Preserves all URL components (origin, path, query params, hash)
 * @param canonicalUrl - The canonical URL to clean (can be full URL or relative path)
 * @returns The cleaned URL with /pwa/ removed from the start of the path if present
 */
export const canonicalUrlCleanup = (canonicalUrl: string): string => {
    // Handle empty string
    if (!canonicalUrl) {
        return canonicalUrl;
    }

    let baseUrl: string;
    let pathUrl: string;

    // Check if it's a full URL or relative URL
    try {
        const url = new URL(canonicalUrl);
        baseUrl = url.origin;
        pathUrl = url.pathname + url.search + url.hash;
    } catch {
        // It's a relative URL, use as is
        baseUrl = '';
        pathUrl = canonicalUrl;
    }

    // Apply the same logic as before for path cleaning
    const cleanedPathUrl = pathUrl.replace(/^\/pwa\//, '/');
    return baseUrl + cleanedPathUrl;
};
